<template>
  <zm-alert v-if="cmrPaywallTipVisible" class="opc-cmr-paywall-tip" type="info" :closable="false" :show-icon="false">
    <i class="zm-icon-info opc-cmr-paywall-tip__icon" aria-hidden="true" />
    <div class="opc-cmr-paywall-tip__message" v-html="tipMsg" />
  </zm-alert>
</template>

<script>
import { mapGetters } from 'vuex'
import { BASE_PLAN_SUB_TYPES, CMR_STORAGE_FOR_MEETING_PLAN } from '@/common/constants'
import { getTitleNameI18nKey, ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils'

export const CMR_PAYWALL_TIP_TYPES = {
  PRO: 'pro',
  BIZ: 'biz',
  BIZ_PLUS: 'biz-plus',
  PRO_PLUS: 'pro-plus',
}

function getBasePlanNameI18nKey(type) {
  switch (type) {
    case CMR_PAYWALL_TIP_TYPES.PRO:
      return getTitleNameI18nKey(ZOOM_MEETING_SUB_TYPES.PRO)
    case CMR_PAYWALL_TIP_TYPES.BIZ:
      return getTitleNameI18nKey(ZOOM_MEETING_SUB_TYPES.BIZ)
    case CMR_PAYWALL_TIP_TYPES.BIZ_PLUS:
      return getTitleNameI18nKey(ZOOM_MEETING_SUB_TYPES.BIZ_PLUS)
    case CMR_PAYWALL_TIP_TYPES.PRO_PLUS:
      return getTitleNameI18nKey(ZOOM_MEETING_SUB_TYPES.PRO_PLUS)
    default:
      return
  }
}

function getCapacity(type) {
  switch (type) {
    case CMR_PAYWALL_TIP_TYPES.PRO:
      return CMR_STORAGE_FOR_MEETING_PLAN[BASE_PLAN_SUB_TYPES.PRO]
    case CMR_PAYWALL_TIP_TYPES.BIZ:
      return CMR_STORAGE_FOR_MEETING_PLAN[BASE_PLAN_SUB_TYPES.BIZ]
    case CMR_PAYWALL_TIP_TYPES.BIZ_PLUS:
      return CMR_STORAGE_FOR_MEETING_PLAN[BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]
    case CMR_PAYWALL_TIP_TYPES.PRO_PLUS:
      return CMR_STORAGE_FOR_MEETING_PLAN[BASE_PLAN_SUB_TYPES.ZOOM_ONE_PRO_PLUS]
    default:
      return
  }
}

export default {
  props: {
    type: {
      type: String,
      required: true,
      validator: (val) => Object.values(CMR_PAYWALL_TIP_TYPES).includes(val),
    },
  },

  computed: {
    ...mapGetters(['cmrPaywallTipVisible']),
    tipMsg() {
      const basePlanNameI18nKey = getBasePlanNameI18nKey(this.type)
      const basePlanName = basePlanNameI18nKey ? this.$t(basePlanNameI18nKey) : ''
      const capacity = getCapacity(this.type) ?? ''
      const cmrPlanName = this.$t('billing.cmr.title')
      return this.$t('billing.cmr.paywall_tip', [
        `<span class="text-capitalize">${basePlanName}</span>`,
        capacity,
        `<span class="text-capitalize">${cmrPlanName}</span>`,
      ])
    },
  },
}
</script>

<style lang="scss" scoped>
.opc-cmr-paywall-tip {
  margin-bottom: 24px;
  background-color: #f7f7f8;

  ::v-deep {
    .zm-alert {
      &__body {
        padding: 0;
      }
      &__description {
        display: flex;
        align-items: center;
      }
    }
  }

  &__icon {
    flex-shrink: 0;
    font-size: 16px;
    color: #666487;
  }
  &__message {
    flex-grow: 1;
    margin-left: 16px;
    line-height: 1.5;
    font-size: 14px;
    font-weight: 450;
    font-style: normal;
    color: #666487;
  }
}
</style>
